import { ErrorMessage, FieldProps } from "formik";
import React, { useState } from "react";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const InputPassword = ({
  label,
  placeholder,
  id,
  field,
  meta,
}: FieldProps & {
  label: string;
  placeholder: string;
  id: string;
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-floating mb-3 position-relative">
      <input
        id={id}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        className={`form-control ps-3 ${meta.touched && meta.error ? "is-invalid" : ""}`}
        {...field}
      />
      <label htmlFor={id} className="form-label text-gray ps-3 z-1">
        {label}
      </label>
      <span
        className={`position-absolute translate-middle-y cursor-pointer top-50 ${meta.touched && meta.error ? "eye-error" : "end-0 pe-4"}`}
        onClick={togglePasswordVisibility}
      >
        {showPassword ? <Eye /> : <EyeSlash />}
      </span>
      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback"
      />
    </div>
  );
};
export default InputPassword;
